<template>
  <span class="geometry-type-icon" :class="`geometry-type-icon--${family || 'unknown'}`">
    <svg
      v-if="family"
      viewBox="0 0 24 24"
      role="img"
      :aria-label="label"
      focusable="false"
    >
      <title>{{ label }}</title>
      <template v-if="family === 'point'">
        <circle cx="12" cy="12" r="4.25" />
      </template>
      <template v-else-if="family === 'line'">
        <path d="M3.5 17.5 9 8.5l5 4 6.5-7" />
        <circle cx="3.5" cy="17.5" r="1.25" />
        <circle cx="9" cy="8.5" r="1.25" />
        <circle cx="14" cy="12.5" r="1.25" />
        <circle cx="20.5" cy="5.5" r="1.25" />
      </template>
      <template v-else-if="family === 'raster'">
        <path class="raster-cells" d="M3.75 3.75h5.5v5.5h-5.5zM14.75 3.75h5.5v5.5h-5.5zM9.25 9.25h5.5v5.5h-5.5zM3.75 14.75h5.5v5.5h-5.5zM14.75 14.75h5.5v5.5h-5.5z" />
        <path class="raster-grid" d="M9.25 3.75v16.5M14.75 3.75v16.5M3.75 9.25h16.5M3.75 14.75h16.5" />
        <rect class="raster-frame" x="3.75" y="3.75" width="16.5" height="16.5" />
      </template>
      <template v-else>
        <path d="M4 18.5 5.5 7l7-3 7 5-2 10-8.5 1Z" />
      </template>
    </svg>
    <span v-else class="geometry-type-icon__unknown" :title="unknownLabel" :aria-label="unknownLabel">
      {{ loading ? '…' : '—' }}
    </span>
  </span>
</template>

<script>
import { normalizeGeometryFamily } from '@/services/layers/geometryType.js'

const GEOMETRY_LABELS = {
  point: 'Geometría de punto',
  line: 'Geometría de línea',
  polygon: 'Geometría de polígono',
  raster: 'Geometría raster'
}

export default {
  name: 'GeometryTypeIcon',
  props: {
    type: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  computed: {
    family() {
      return normalizeGeometryFamily(this.type)
    },
    label() {
      return GEOMETRY_LABELS[this.family] || 'Geometría sin información'
    },
    unknownLabel() {
      return this.loading ? 'Consultando tipo de geometría' : 'Tipo de geometría sin información'
    }
  }
}
</script>

<style scoped>
.geometry-type-icon {
  display: inline-flex;
  width: 1.65rem;
  height: 1.65rem;
  align-items: center;
  justify-content: center;
  color: var(--color-navy);
  vertical-align: middle;
}

.geometry-type-icon svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.geometry-type-icon--point circle {
  fill: currentColor;
}

.geometry-type-icon--line path,
.geometry-type-icon--line circle {
  fill: currentColor;
  stroke: currentColor;
}

.geometry-type-icon--line path {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.geometry-type-icon--polygon path {
  fill: currentColor;
  fill-opacity: 0.18;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linejoin: round;
}

.geometry-type-icon--raster .raster-frame,
.geometry-type-icon--raster .raster-grid {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.25;
}

.geometry-type-icon--raster .raster-cells {
  fill: currentColor;
}

.geometry-type-icon__unknown {
  color: #6c7883;
  font-size: 1rem;
}
</style>
